<template>
  <div>
    <span class="role-table" v-if="agent">
      {{ formatUserType(agent.type) }}
    </span>
    <a
      v-if="agent"
      class="text-capitalize hide-data"
      :href="`/partners/${agent._id}`"
      target="_blank"
    >
      {{ getAgentName(agent) }}
    </a>
    <span v-else class="text-danger text-capitalize">Unassigned</span>
  </div>
</template>

<script>
export default {
  name: "ShowAgent",
  props: {
    agent: {
      type: Object,
      default: null
    }
  },
  methods: {
    getAgentName(agent) {
      if (!agent) return "Unassigned";
      return `${agent.first_name} ${agent.last_name}`;
    },
    formatUserType(type) {
      if (type === "admin") {
        return "Admin";
      } else if (type === "driver") {
        return "Driver";
      } else if (type === "suppliers") {
        return "Supplier";
      } else if (type === "customer") {
        return "Customer";
      } else if (type === "ote") {
        return "OTE";
      } else if (type === "travel_agency") {
        return "Travel Agency";
      } else if (type === "travel_access") {
        return "Agent";
      } else if (type === "business") {
        return "Business";
      } else if (type === "guest") {
        return "Guest";
      }
      return "Client";
    }
  }
};
</script>
